"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastNameValidationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@framework/constants");
exports.lastNameValidationSchema = (0, yup_1.string)()
    .min(constants_1.lastNameMinLength, "form.validations.tooShort")
    .max(constants_1.lastNameMaxLength, "form.validations.tooLong")
    .required("form.validations.valueMissing");
//# sourceMappingURL=last-name.js.map